import { FC } from "react";
import { format } from "date-fns";
import { Tooltip } from "@mui/material";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers-pro";
import __ from "src/utils/Translations";
import findInExcludedDays from "src/utils/Company/Absences/findInExcludedDays";
import { IExcludedDay } from "src/Pages/Company/Absences/Calendars/Calendars.models";
import {
  getPreviewStyles,
  defaultPreviewStyles,
} from "./CalendarPicker.styles";

interface ICustomCalendarDayProps extends PickersDayProps {
  excludedDays: IExcludedDay[];
}

const CustomCalendarDay: FC<ICustomCalendarDayProps> = ({
  excludedDays = [],
  ...props
}) => {
  const { day } = props as PickersDayProps;
  const excluded = findInExcludedDays(day, excludedDays);
  const isExcluded = !!excluded && excluded.label;

  return (
    <>
      {isExcluded ? (
        <Tooltip title={excluded.label} placement="top" arrow>
          <PickersDay
            {...props}
            sx={getPreviewStyles(excluded.color)}
            data-testid="absences-calendar-picker-excluded"
          >
            {format(day, "d")}
          </PickersDay>
        </Tooltip>
      ) : (
        <PickersDay
          {...props}
          sx={defaultPreviewStyles}
          data-testid="absences-calendar-picker-day-preview"
        >
          <>{format(day, "d")}</>
        </PickersDay>
      )}
    </>
  );
};

export default CustomCalendarDay;
